import styled from 'styled-components';
import { COLOR_LINK } from 'constants/colors';

export const MainContainer = styled.div`
  display: flex;
  & > * {
    flex: 1;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  margin-right: 0.5rem;
`;

export const PopoverContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
`;

export const ActionButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;

  &:hover {
    text-decoration: underline;
    background: transparent;
    color: ${COLOR_LINK};
  }

  &.ant-btn:not([disabled]):hover {
    text-decoration: underline;
  }
`;
